import React from 'react'
import './header.css'

const Header = () => {
    return (
        <header className='header' id='header'>
            <div className='header__veil' />
            <div className='header__content'>
                <p className='header__eyebrow'>Proyecto feminista de cultura menstrual</p>
                <h1>La Vida en Rojo</h1>
                <h2>Asociación de cultura menstrual</h2>
                <p className='header__lead'>
                    Educación, investigación, divulgación, activismo y red para la justicia social, los derechos humanos y el cuidado de los ecosistemas.
                </p>
                <div className='header__actions'>
                    <a className='main__button main__button--alt' href='https://www.lavidaenrojo.org/libro'>Comprar libro</a>
                    <a className='main__button header__button--ghost' href='https://www.lavidaenrojo.org/hazte-amiga'>Sumarme a la red</a>
                </div>
            </div>
        </header>
    )
}

export default Header
